module.exports = __webpack_public_path__ + "static/media/img-2.9b4132a5.png";